/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');

window.Vue = require('vue');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import "./directives"
import router from "./router";
import store from './store'
import App from "./App.vue";
import * as types from "./store/types"

import { ModalPlugin } from 'bootstrap-vue/src/components/modal'
Vue.use(ModalPlugin)

import { ButtonPlugin } from 'bootstrap-vue/src/components/button'
Vue.use(ButtonPlugin)

import { DropdownPlugin } from 'bootstrap-vue/src/components/dropdown'
Vue.use(DropdownPlugin)

import { NavbarPlugin } from "bootstrap-vue/src/components/navbar";
Vue.use(NavbarPlugin)

import { TabsPlugin } from "bootstrap-vue/src/components/tabs";
Vue.use(TabsPlugin)

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    return response;
}, function (error) {
    // might want to chek for particular status codes
    if(error.response.status == 401){
        store.dispatch('auth/'+types.AUTH_LOGOUT).then(() => {
            router.push({ name: 'login'})
        })
    }
    // Do something with response error
    return Promise.reject(error);
});

const app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
